export default {
  title: 'Other accounts',
  subtitle1: 'For ',
  subtitle2: ', the following accounts are found:',
};
